import 'vite/modulepreload-polyfill'
import {debounce} from 'throttle-debounce';
import $ from "jquery";

$.fn.teilnehmersuche = function (args) {
    let defaults =
        {
            query: '',
            limit: 10,
            tippsaisonId: 0,
            teamId: 0,
            gruppeId: 0,
            gruppierungWertung: '',
            teilnehmerLinkUrl: '',
            suchfelder: false,
            teilnehmerIdParameterName: 'teilnehmerId',
            teilnehmerIdDataName: 'teilnehmer-id',
            teilnehmerNameDataName: 'teilnehmer-name',
            teilnehmerParameterName: 'teilnehmer',
            excludeTipperId: 0,
            excludeRolleInaktiv: true,
            excludeRolleSchwebdend: false,
            excludeTeammitglieder: false,
            excludeMitgliederAusGruppierung: 0,
            callback: null
        };
    let options = $.extend(defaults, args);
    let teilnehmersucheDiv;
    let nameInput;
    let selectedName;
    let blaetternUpDiv;
    let blaetternDownDiv;
    let lastName = '';

    function bindElements() {
        $(blaetternUpDiv).click(blaetternUp);
        $(blaetternDownDiv).click(blaetternDown);
        $(nameInput).on('input', debounceNameInput);
        $(nameInput).keydown(inputKeyDown);
    }

    const debounceNameInput = debounce(
        500,
        () => {
            let name = $(nameInput).val();
            if (name !== lastName) {
                let offset = 0;
                lastName = name;
                reloadTeilnehmer(offset, name);
            }
            return false;
        },
        {atBegin: false}
    );

    // Beim Drücken der Enter Taste wird der erste Eintrag der Liste ausgewählt. Außerdem wird ein Form Submit unterbunden.
    function inputKeyDown(event) {
        if (event.which === 13) {
            let firstSelection = $('.resultrow a').first();
            if (firstSelection.length) {
                firstSelection[0].click();
            }
            event.preventDefault();
            return false;
        }
    }

    function blaetternUp() {
        let offset = Number($(this).attr('data-offset')) || 0;
        let name = $(nameInput).val();
        if( name === selectedName){
            name = '';
        }
        reloadTeilnehmer(offset, name).then(r => $(this).blur());
    }

    function blaetternDown() {
        let offset1 = Number($(this).attr('data-offset')) || 0;
        let name = $(nameInput).val();
        if( name === selectedName){
            name = '';
        }
        reloadTeilnehmer(offset1, name).then(r => {
            $(this).focusout();
            let offset2 = $(teilnehmersucheDiv).find('div.teilnehmer').first().offset();
            window.scrollTo(0, offset2.top);
        });
    }

    async function reloadTeilnehmer(offset, name) {
        if (options.query === 'tippersuche') {
            reloadTipper(offset, name);
        } else {
            if (options.query === 'teamsuche') {
                reloadTeams(offset, name);
            } else {
                if (options.query === 'gruppensuche') {
                    reloadGruppen(offset, name);
                }
            }
        }
    }

    async function reloadTipper(offset, name) {
        const query = {
            query: 'query tippersuche($tippersucheForm: TippersucheFormInput!){ tippersuche( tippersucheForm: $tippersucheForm) {prevTipper nextTipper offset limit tipperDTOs { id name }}}',
            variables: {
                tippersucheForm: {
                    tippsaisonId: options.tippsaisonId,
                    name: name,
                    offset: offset,
                    limit: options.limit,
                    excludeTipperId: options.excludeTipperId,
                    excludeRolleSchwebend: options.excludeRolleSchwebend,
                    excludeRolleInaktiv: options.excludeRolleInaktiv,
                    excludeTeammitglieder: options.excludeTeammitglieder,
                    excludeMitgliederAusGruppierung: options.excludeMitgliederAusGruppierung,
                    teamId: options.teamId,
                    gruppeId: options.gruppeId
                }
            }
        };
        graphql(query).then(json => {
            const tippersucheDTO = json.data.tippersuche
            updateTeilnehmer(tippersucheDTO.prevTipper, tippersucheDTO.nextTipper, tippersucheDTO.offset, tippersucheDTO.limit, tippersucheDTO.tipperDTOs);
        });
    }

    async function reloadTeams(offset, name) {
        const query = {
            query: 'query teamsuche($teamsucheForm: TeamsucheFormInput!){ teamsuche( teamsucheForm: $teamsucheForm) {prevTeams nextTeams offset limit teamDTOs { id name }}}',
            variables: {
                teamsucheForm: {
                    tippsaisonId: options.tippsaisonId,
                    name: name,
                    offset: offset,
                    limit: options.limit,
                    ausreichendeTeamgroesse: true
                }
            }
        };
        graphql(query).then(json => {
            const teamsucheDTO = json.data.teamsuche
            updateTeilnehmer(teamsucheDTO.prevTeams, teamsucheDTO.nextTeams, teamsucheDTO.offset, teamsucheDTO.limit, teamsucheDTO.teamDTOs);
        });
    }


    async function reloadGruppen(offset, name) {
        const query = {
            query: 'query gruppensuche($gruppensucheForm: GruppensucheFormInput!){ gruppensuche( gruppensucheForm: $gruppensucheForm) {prevGruppen nextGruppen offset limit gruppeDTOs { id name suchfelder }}}',
            variables: {
                gruppensucheForm: {
                    tippsaisonId: options.tippsaisonId,
                    wertung: options.gruppierungWertung,
                    name: name,
                    offset: offset,
                    suchfelder: options.suchfelder,
                    limit: options.limit
                }
            }
        }
        graphql(query).then(json => {
            const gruppensucheDTO = json.data.gruppensuche;
            updateTeilnehmer(gruppensucheDTO.prevGruppen, gruppensucheDTO.nextGruppen, gruppensucheDTO.offset, gruppensucheDTO.limit, gruppensucheDTO.gruppeDTOs);
        });
    }

    function updateTeilnehmer(showPrev, showNext, offset, limit, teilnehmerDTOs) {
        let keineAuswahl = $('#keineAuswahl');
        keineAuswahl.hide();
        let lastDiv = null;
        updateBlaetternUp(showPrev, offset, limit);
        if (blaetternUpDiv !== null && blaetternUpDiv.length) {
            lastDiv = blaetternUpDiv;
        }
        $(teilnehmersucheDiv).find('div.teilnehmer').remove();
        if (teilnehmerDTOs.length === 0) {
            keineAuswahl.show();
        } else {
            $.each(teilnehmerDTOs, function (index, teilnehmerJson) {
                let teilnehmerDiv = getTeilnehmerDiv(teilnehmerJson);
                if (lastDiv !== null && lastDiv.length) {
                    teilnehmerDiv.insertAfter(lastDiv)
                } else {
                    $(teilnehmersucheDiv).find('div.results').prepend(teilnehmerDiv);
                }
                lastDiv = teilnehmerDiv;
            });
        }
        updateBlaetternDown(showNext, offset, limit, lastDiv);
        if (typeof options.callback == 'function') {
            options.callback.call(this);
        }
        heightChanged()
    }
    function teilnehmerClick(e) {
        if (typeof options.callback == 'function') {
            return;
        }
        navigate(e.target.href)
    }

    function getTeilnehmerDiv(teilnehmerJson) {
        let teilnehmerDiv = $("<div>",
            {
                class: "level0 teilnehmer resultrow"
            });
        let url = options.teilnehmerLinkUrl + '?' + options.teilnehmerIdParameterName + '=' + teilnehmerJson.id;
        if (options.teilnehmerLinkUrl.indexOf("?") >= 0) {
            url = options.teilnehmerLinkUrl + '&' + options.teilnehmerIdParameterName + '=' + teilnehmerJson.id;
        }
        teilnehmerDiv.data(options.teilnehmerIdDataName, teilnehmerJson.id);
        teilnehmerDiv.data(options.teilnehmerNameDataName, teilnehmerJson.name);
        let anchor = $("<a>",
            {
                href: url,
                click: teilnehmerClick
            });
        if (options.suchfelder) {
            anchor.append(getGruppenMitSuchfelder(teilnehmerJson));
        } else {
            anchor.text(teilnehmerJson.name);
        }
        teilnehmerDiv.append(anchor);
        return teilnehmerDiv;
    }

    function getGruppenMitSuchfelder(teilnehmerJson) {
        let div = '<div class="searchtitle">' + teilnehmerJson.name + '</div><div class="searchsubtitle">'
        for (let index = 0; index < teilnehmerJson.suchfelder.length; index++) {
            if (index > 0) {
                div = div + ', ';
            }
            div = div + teilnehmerJson.suchfelder[index];
        }
        div = div + '</div>';
        return div;
    }

    function updateBlaetternUp(showPrev, offset, limit) {
        if (showPrev) {
            if (blaetternUpDiv !== null && blaetternUpDiv.length) {
                let prevOffset = getBlaetternUpOffset(offset, limit);
                $(blaetternUpDiv).attr('data-offset', prevOffset);
            } else {
                createBlaetternUpDiv(offset, limit);
            }
        } else {
            if (blaetternUpDiv !== null && blaetternUpDiv.length) {
                $(blaetternUpDiv).remove();
                blaetternUpDiv = null;
            }
        }
    }

    function updateBlaetternDown(showNext, offset, limit, lastDiv) {
        if (showNext) {
            if (blaetternDownDiv !== null && blaetternDownDiv.length) {
                let blaetternOffset = getBlaetternDownOffset(offset, limit);
                $(blaetternDownDiv).attr('data-offset', blaetternOffset);
            } else {
                createBlaetternDownDiv(offset, limit, lastDiv);
            }
        } else {
            if (blaetternDownDiv !== null && blaetternDownDiv.length) {
                $(blaetternDownDiv).remove();
                blaetternDownDiv = null;
            }
        }
    }

    function createBlaetternUpDiv(offset, limit) {
        let blaetternOffset = getBlaetternUpOffset(offset, limit);
        blaetternUpDiv = $("<div>",
            {
                class: "blaettern up resultrow"
            });
        blaetternUpDiv.attr('data-offset', blaetternOffset);
        let anchor = $("<a>");
        let span = $("<span>",
            {
                class: "kicktipp-icon-blaettern"
            });
        span.text(' ');
        anchor.append(span);
        blaetternUpDiv.append(anchor);
        $(teilnehmersucheDiv).find('div.results').prepend(blaetternUpDiv);
        blaetternUpDiv.click(blaetternUp);
    }

    function createBlaetternDownDiv(offset, limit, lastDiv) {
        let blaetternOffset = getBlaetternDownOffset(offset, limit);
        blaetternDownDiv = $("<div>",
            {
                class: "blaettern down resultrow"
            });
        blaetternDownDiv.attr('data-offset', blaetternOffset);
        let anchor = $("<a>");
        let span = $("<span>",
            {
                class: "kicktipp-icon-blaettern"
            });
        span.text(' ');
        anchor.append(span);
        blaetternDownDiv.append(anchor);
        blaetternDownDiv.insertAfter(lastDiv);
        blaetternDownDiv.click(blaetternDown);
    }

    function getBlaetternUpOffset(offset, limit) {
        let blaetternUpOffset = offset - limit;
        if (blaetternUpOffset < 0) {
            blaetternUpOffset = 0;
        }
        return blaetternUpOffset;
    }

    function getBlaetternDownOffset(offset, limit) {
        return offset + limit;
    }

    return this.each(function () {
        teilnehmersucheDiv = this;
        nameInput = $(this).find("input");
        selectedName = nameInput.val();
        blaetternUpDiv = $(this).find('.blaettern.up');
        blaetternDownDiv = $(this).find('.blaettern.down');
        bindElements();
    });
}